export default "__VITE_ASSET__BugObT1N__"